/**
 * Selectors for prompt experimentation slice
 */

export const selectPrompts = (state) =>
  state.promptExperimentation?.prompts || {};

export const selectExtractionPrompt = (state) =>
  state.promptExperimentation?.prompts?.extractionPrompt || "";

export const selectSynonymPrompt = (state) =>
  state.promptExperimentation?.prompts?.synonymPrompt || "";

export const selectTestResults = (state) =>
  state.promptExperimentation?.testResults || null;

export const selectIsLoading = (state) =>
  state.promptExperimentation?.loading || false;

export const selectIsTesting = (state) =>
  state.promptExperimentation?.testing || false;

export const selectIsExporting = (state) =>
  state.promptExperimentation?.exporting || false;

export const selectError = (state) =>
  state.promptExperimentation?.error || null;

export const selectLastTestTimestamp = (state) =>
  state.promptExperimentation?.lastTestTimestamp || null;

export const selectHasTestResults = (state) =>
  state.promptExperimentation?.testResults !== null;

export const selectExtractedTerms = (state) =>
  state.promptExperimentation?.testResults?.extractedTerms || [];

export const selectMetrics = (state) =>
  state.promptExperimentation?.testResults?.metrics || null;

export const selectDocumentsSummary = (state) =>
  state.promptExperimentation?.testResults?.documentsSummary || null;
